/**
 * client 和 server 共享的一些工具函数
 * 注意：不要依赖 DOM 和 Node.js 的 API
 */
import dayjs from 'dayjs'
import { customAlphabet } from 'nanoid'

/** 检查 switch case 分支是否对所有 union type 或 enum 的值做了穷举，用在 default 分支中 */
export function assertExhaustive(_value: never, message: string = 'Exhaustive check failed'): never {
  throw new Error(message)
}

export function createTraceId() {
  const alphabet = '0123456789'
  const generate = customAlphabet(alphabet, 5)
  return `trace_${dayjs(new Date()).format('YYYYMMDDHHmmss')}_${generate()}`
}

/** 判断当前是否是node环境，前端环境不支持env配置 */
export function isNodeEnv() {
  // 在Node.js环境中，process对象是全局可用的
  return typeof process !== 'undefined' && process.versions && process.versions.node
}

/** ms 转 s，语义化的表达，保留1为小数 */
export function msToS(ms: number) {
  return Math.round(ms / 100) / 10 + '秒'
}

export function isValidJSON(str: string) {
  try {
    JSON.parse(str)
    return true
  } catch (e) {
    return false
  }
}

export function isEmptyArray(obj: any) {
  return Array.isArray(obj) && obj.length === 0
}

/**
 * Convert Amap API field to string. Amap returns [] for empty values,
 * string for normal values, and potentially string[] in edge cases.
 */
export function toStringValue(val: any): string {
  if (Array.isArray(val)) return val.join('')
  return val ?? ''
}

export function getProviderFromPath(path: string, response?: string) {
  if (path === '/regeocode-amap' || path === '/search-amap') return '高德地图'
  if (path === '/regeocode-gmap' || path === '/search-gmap') return '谷歌地图'
  if (path === '/search-text' && response) {
    try {
      const data = JSON.parse(response)
      if (Array.isArray(data) && data.length > 0) {
        // mapProvider: 1 = Google, 2 = Amap
        return data[0].mapProvider === 2 ? '高德地图' : '谷歌地图'
      }
    } catch {
      // ignore JSON parse errors
    }
  }
  return '未知'
}
